import React, { useState } from 'react';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { IntlPageTitle } from 'components/intl/IntlPageTitle';
import { ModalIntro } from 'components/layout/ModalIntro';
import userAdminSrc from 'assets/media/user-admin.png';
import { FormattedMessage } from 'react-intl';
import { ShouldRender } from '../../../../../ShouldRender';
import { Groups } from './components/Groups';
// eslint-disable-next-line import/no-cycle
import { GroupForm } from './components/Groups/components/GroupForm';
import { Resources } from './components/Resources';
import { ResourceForm } from './components/Resources/components/ResourceForm';
import { AddResourceForm } from './components/Resources/components/AddResourceForm';
import { AddGroupForm } from './components/Groups/components/AddGroupForm';
import { AccessManagement2NModalContext } from './components/AccessManagement2NModalContext';

export const AccessManagement2NModal = () => {
    
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedResource, setSelectedResource] = useState(null);
  const [showGroups, setShowGroups] = useState(true);
  const [showResources, setShowResources] = useState(false);
  const [isAddingResource, setIsAddingResource] = useState(false);
  const [isAddingGroup, setIsAddingGroup] = useState(false);

  return (
    <AccessManagement2NModalContext.Provider
      value={{ selectedGroup,
        setSelectedGroup,
        selectedResource,
        setSelectedResource,
        isAddingResource,
        setIsAddingResource,
        isAddingGroup,
        setIsAddingGroup,
      }}
    >
      <Grid brikkLayout>
        <IntlPageTitle intlTitle="twoNAccessManagement" />

        <Grid.Column>
          <Brikk.Heading
            main
            heading="twoNAccessManagement"
          >
            <ModalIntro>
              <ModalIntro.Image
                src={userAdminSrc}
                alt="twoNAccessManagement"
              />

              <div>
                { /* TODO: Uncomment groups when the groups functionality is implemented */}
                <ModalIntro.Card onClick={() => {
                  setShowGroups(true);
                  setShowResources(false);
                  setSelectedResource(null);
                }}
                > <FormattedMessage id="accessGroupsTitle" />
                </ModalIntro.Card>
                {/* <ModalIntro.Card onClick={() => {
                  setShowResources(true);
                  setShowGroups(false);
                  setSelectedGroup(null);
                }}
                > <FormattedMessage id="accessGroupsResourcesTitle" />
                </ModalIntro.Card> */}
              </div>
            </ModalIntro>
          </Brikk.Heading>

        </Grid.Column>

        <ShouldRender condition={showGroups}> 
          <Grid.Column>
            <Groups />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={isAddingGroup}>
          <Grid.Column>
            <AddGroupForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={!isAddingGroup && !showResources}>
          <Grid.Column>
            <GroupForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={showResources}>
          <Grid.Column>
            <Resources />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={isAddingResource}>
          <Grid.Column>
            <AddResourceForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={!isAddingResource && !showGroups}>
          <Grid.Column>
            <ResourceForm />
          </Grid.Column>
        </ShouldRender>

      </Grid>
    </AccessManagement2NModalContext.Provider>
  );
};
